module.exports = __webpack_public_path__ + "static/media/img5.3fc10dca.svg";